<script setup lang="ts">
import { PhCaretLeft, PhCaretRight } from "@phosphor-icons/vue";
</script>

<template>
  <section id="imageViewer" class="image-viewer" aria-label="大图查看" hidden>
    <header class="view-header">
      <button id="viewerBackButton" class="icon-button" type="button" aria-label="返回图片列表">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="viewerTitle">商品主图</h2>
        <span id="viewerCounter">1 / 1</span>
      </div>
    </header>
    <div id="imageStage" class="image-stage">
      <img id="viewerImage" alt="" draggable="false" />
      <input
        id="viewerSelectionCheckbox"
        class="media-selection-checkbox detail-selection-checkbox"
        type="checkbox"
        aria-label="选择当前图片"
      />
      <button id="imagePreviousButton" class="image-arrow image-arrow--previous" type="button" aria-label="上一张图片">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <button id="imageNextButton" class="image-arrow image-arrow--next" type="button" aria-label="下一张图片">
        <PhCaretRight :size="18" weight="bold" aria-hidden="true" />
      </button>
    </div>
    <p id="viewerCaption" class="viewer-caption"></p>
  </section>
</template>
